import styled from '@emotion/styled';
import { breakpoint, colors, spacing, typography } from 'component-library';
import { StyledBadge } from '../components/styles';

export const ItemLabel = styled.span<{ bold: boolean }>`
  ${typography.body.large};
  ${({ bold }) => bold && typography.body.largeBold};
`;

export const ItemDetails = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing.tiny};
`;

export const ItemDescription = styled.span`
  ${typography.body.medium};
  color: ${colors.primary.grey};
`;

export const ItemBadge = styled(StyledBadge)`
  @media (min-width: ${breakpoint.medium}px) {
    position: static;
  }
`;

export const InactiveToggleButton = styled.button`
  ${typography.body.large};
  box-sizing: border-box;
  display: grid;
  grid-template-columns: ${spacing.small} 1fr;
  gap: ${spacing.xsmall};
  align-items: center;
  padding: ${spacing.xmsmall};
  border: none;
  background: transparent;
  color: ${colors.base.black};
  font-family: inherit;
  text-align: left;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: ${colors.background.grey};
  }
`;
